







































import Vue from 'vue';
import { mapState } from 'vuex';
import * as utils from '@/lib/utils';
import RidesTable from '@/components/Reports/RidesTable.vue';
import TicketsReport from '@/components/Reports/TicketsReport.vue';
import RatingsTable from '@/components/Reports/RatingsTable.vue';
import TicketsHistoryReport from '@/components/Reports/TicketsHistoryReport.vue';
import {
    convertDatetimeToTz, convertDateToAmericanFormat, AMERICAN_DATE_FORMAT, TIME_FORMAT,
} from '@/lib/utils';

export default Vue.extend({
    components: {
        RidesTable,
        TicketsReport,
        TicketsHistoryReport,
        RatingsTable,
    },
    data() {
        return {
            perGroup: 'By route',
            dates: [] as Array<string>,
            ridesReportData: [],
            ridesReportLoading: false,
            ticketsReportData: [],
            ticketsReportLoading: false,
            ticketsHistoryReportData: [],
            ticketsHistoryReportLoading: false,
            ratingsReportData: [],
            ratingsReportLoading: false,
            chartOptions: {
                chart: {
                    type: 'bar',
                    id: 'areachart-2',
                    toolbar: {
                        show: false,
                        autoSelected: 'pan',
                    },
                },
                stroke: {
                    curve: 'straight',
                },
                grid: {
                    padding: {
                        right: 10,
                        left: 20,
                    },
                },
                xaxis: {
                    type: 'datetime',
                    max: new Date().getTime(),
                    min: new Date().getTime(),
                },
                yaxis: {
                    title: {
                        text: 'Booked Tickets',
                    },
                    min: 0,
                    max: 20,
                },
            },
        };
    },
    methods: {
        dateChanged(newDates: any) {
            this.dates = newDates;
        },
        async getRidesReport(fromDate: string, toDate: string) {
            try {
                this.ridesReportData = [];
                this.ridesReportLoading = true;

                this.ridesReportData = (await this.$hipApi.getRidesFromDates(fromDate, toDate)).map((r: any) => {
                    r.booked = parseInt(r.boardedPassengers) + parseInt(r.nonBoardedPassengers);
                    return r;
                });

                // TODO: this is a temp fix!
                if (this.corp.name === 'Asana') {
                    const routeMap = new Map();
                    this.ridesReportData.forEach((ride: any) => {
                        if (routeMap.has(ride.routeName)) {
                            const val = routeMap.get(ride.routeName);
                            routeMap.set(ride.routeName, parseInt(val) + parseInt(ride.booked));
                        } else {
                            routeMap.set(ride.routeName, parseInt(ride.booked));
                        }
                    });
                    const maxY = 10;
                    const maxBooked = Math.max(...routeMap.values());
                    this.chartOptions.yaxis.max = maxY > maxBooked ? maxY : maxBooked + 1;
                }

                this.chartOptions.xaxis.min = new Date(fromDate).getTime() - 1;
                this.chartOptions.xaxis.max = new Date(toDate).getTime() + 1;
                if (this.$refs.apexchart) {
                    // @ts-ignore
                    this.$refs.apexchart.refresh();
                }

                this.ridesReportLoading = false;
            } catch (err) {
                this.$notifier.showError(err?.error?.message || err?.message || err);
            }
        },
        async getTicketsReport(fromDate: string, toDate: string) {
            try {
                this.ticketsReportLoading = true;
                this.ticketsReportData = [];
                this.ticketsReportData = await this.$hipApi.getTicketsReport(fromDate, toDate);
                this.ticketsReportLoading = false;
            } catch (err) {
                this.$notifier.showError(err?.error?.message || err?.message || err);
            }
        },
        async getTicketsHistoryReport(fromDate: string, toDate: string) {
            try {
                this.ticketsHistoryReportLoading = true;
                this.ticketsHistoryReportData = [];
                this.ticketsHistoryReportData = await this.$hipApi.getTicketsHistoryReport(fromDate, toDate);
                this.ticketsHistoryReportLoading = false;
            } catch (err) {
                this.$notifier.showError(err?.error?.message || err?.message || err);
            }
        },
        async getRatingsReport(fromDate: string, toDate: string) {
            try {
                this.ratingsReportLoading = true;
                this.ratingsReportData = [];
                this.ratingsReportData = (await this.$hipApi.getRatings(fromDate, toDate)).ratings;
                this.ratingsReportLoading = false;
            } catch (err) {
                this.$notifier.showError(err?.error?.message || err?.message || err);
            }
        },
        exportToCsv() {
            const csvData = this.getCsvData();
            const filePrefix = this.getFilePrefix();
            const fileName = `hq_shuttles_${filePrefix}_report_${this.dates[0]}_to_${this.dates[1]}.csv`;
            const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
            if (navigator && navigator.msSaveBlob) {
                // IE 10+
                navigator.msSaveBlob(blob, fileName);
            } else {
                const link = document.createElement('a');
                const url = URL.createObjectURL(blob);
                link.setAttribute('href', url);
                link.setAttribute('download', fileName);
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        },
        exportToCsvDisabled() {
            switch (this.perGroup) {
            case 'By route':
                return this.ridesReportData.length === 0;
            case 'By employee':
                return this.ticketsReportData.length === 0;
            case 'By date':
                return this.ticketsHistoryReportData.length === 0;
            case 'By ratings':
                return this.ratingsReportData.length === 0;
            default:
                return true;
            }
        },
        getCsvData(): string {
            switch (this.perGroup) {
            case 'By route':
                return this.chartCsvData;
            case 'By employee':
                return this.ticketsCsvData;
            case 'By date':
                return this.ticketsHistoryCsvData;
            case 'By ratings':
                return this.ratingsCsvData;
            default:
                return '';
            }
        },
        getFilePrefix() {
            let filePrefix;
            switch (this.perGroup) {
            case 'By route':
                filePrefix = this.reports.chartTitlePerRoute;
                break;
            case 'By employee':
                filePrefix = this.reports.chartTitlePerEmployee;
                break;
            case 'By date':
                filePrefix = this.reports.chartTitlePerDate;
                break;
            case 'By ratings':
                filePrefix = this.reports.chartTitlePerRatings;
                break;
            default:
                filePrefix = '';
            }
            return filePrefix.toLowerCase().replace(/ /g, '_');
        },
    },
    computed: {
        ...mapState('texts', ['reports']),
        ...mapState('offices', ['corp']),
        ...mapState('tenants', ['tenants']),
        dateRangeText(): string {
            if (this.dates.length === 2) {
                return `${utils.convertDateToAmericanFormat(this.dates[0] as string)} - ${utils.convertDateToAmericanFormat(this.dates[1] as string)}`;
            }
            return `${utils.convertDateToAmericanFormat(this.dates[0] as string)}`;
        },
        chartData() {
            const newSeries: any = [];
            // TODO: this is a temp fix!
            if (this.corp.name === 'Asana') {
                this.ridesReportData.forEach((ride: any) => {
                    const seriesElement = newSeries.find((val: any) => val?.name === `${ride.routeName}`);
                    if (ride.booked >= 0) {
                        if (seriesElement) {
                            const exist = seriesElement.data.find((val: any) => val.date === ride.date);
                            if (exist) {
                                exist.y += ride.booked;
                            } else {
                                seriesElement.data.push({ x: new Date(ride.date).getTime(), date: ride.date, y: ride.booked });
                            }
                        } else {
                            newSeries.push({
                                name: `${ride.routeName}`,
                                data: [{ x: new Date(ride.date).getTime(), date: ride.date, y: ride.booked }],
                            });
                        }
                    }
                });
            } else {
                this.ridesReportData.forEach((ride: any) => {
                    const seriesElement = newSeries.find((val: any) => val?.name === `${ride.routeName} (${utils.tConvert(ride.scheduledDeparture)})`);
                    if (ride.booked >= 0) {
                        if (seriesElement) {
                            seriesElement.data.push({ x: new Date(ride.date).getTime(), date: ride.date, y: ride.booked });
                        } else {
                            newSeries.push({
                                name: `${ride.routeName} (${utils.tConvert(ride.scheduledDeparture)})`,
                                data: [{ x: new Date(ride.date).getTime(), date: ride.date, y: ride.booked }],
                            });
                        }
                    }
                });
            }
            return newSeries;
        },
        chartCsvData() {
            // first line
            const allRouteNames = this.chartData.map((route: any) => route.name) as string[];
            let csv = `Date,${allRouteNames.join(',')}\n`;

            // data lines
            const fromDate = this.dates[0];
            const toDate = this.dates[1];
            const totalNumOfDays = utils.getDaysDiff(fromDate, toDate);
            for (let i = 0; i <= totalNumOfDays; i++) {
                const date = utils.incrementDateByDays(i, fromDate);
                const lineData = this.chartData.map((dataForRoute: any) => {
                    const dateData = dataForRoute.data.find((d: any) => d.date === date);
                    return dateData ? dateData.y : '';
                }) as string[];
                csv += `${date},${lineData.join(',')}\n`;
            }

            return csv;
        },
        ticketsCsvData() {
            let csv = '';
            csv = `Name,Email${this.tenants.length > 0 ? ',Tenant' : ''},Rides Taken, Rides Cancelled, Rides Missed\n`;
            this.ticketsReportData.forEach((row: any) => {
                const tenantName = this.tenants.find((t: any) => t.tenantId === row?.tenantId)?.firmName || '';
                csv += `${row.name},${row.email}${this.tenants.length > 0 ? `,${tenantName}` : ''},${row.used},${row.cancelled},${row.valid}\n`;
            });
            return csv;
        },
        ticketsHistoryCsvData() {

            // first line
            let csv = '';
            // eslint-disable-next-line max-len
            csv = `Date,PUtime,DOtime,PUstop,DOstop,Status,Name,Email${this.tenants.length > 0 ? ',Tenant' : ''},Booked at date,Booked at time,Used at date, Used at time,Cancelled at date, Cancelled at time`;
            csv += this.corp.isPaymentDisabled ? '\n' : ',Charge,Credit\n';

            // data lines
            this.ticketsHistoryReportData.forEach((row: any) => {
                const tenantName = this.tenants.find((t: any) => t.tenantId === row?.tenantId)?.firmName || '';
                csv += `${convertDateToAmericanFormat(row.ticketDate)},${row.PUtime},${row.DOtime},${row.PUstop},${row.DOstop},${row.ticketStatus === 'valid' ? 'unused' : row.ticketStatus},${
                    row.name
                },${
                    row.email
                }${this.tenants.length > 0 ? `,${tenantName}` : ''},${convertDatetimeToTz(row.bookedAt, row.tz, AMERICAN_DATE_FORMAT)},${convertDatetimeToTz(row.bookedAt, row.tz, TIME_FORMAT)},${
                    row.usedAt ? convertDatetimeToTz(row.usedAt, row.tz, AMERICAN_DATE_FORMAT) : ''
                },${row.usedAt ? convertDatetimeToTz(row.usedAt, row.tz, TIME_FORMAT) : ''},${row.cancelledAt ? convertDatetimeToTz(row.cancelledAt, row.tz, AMERICAN_DATE_FORMAT) : ''},${
                    row.cancelledAt ? convertDatetimeToTz(row.cancelledAt, row.tz, TIME_FORMAT) : ''
                }`;

                csv += this.corp.isPaymentDisabled ? '\n' : `,${row.chargeAmount},${row.creditAmount}\n`;
            });

            return csv;
        },
        ratingsCsvData() {
            let csv = 'Name,Date,Route,Rating,Details,Comments\n';
            this.ratingsReportData.forEach((row: any) => {
                console.log(JSON.stringify(row));
                const suggestions = JSON.stringify(row.suggestionsChosen).replace(new RegExp(',', 'g'), '|');
                csv += `${row.fullName},${convertDateToAmericanFormat(row.updated)},${row.routeName},${row.rating},${suggestions},${row.freeText ?? ' '}\n`;
            });
            return csv;
        },
    },
    mounted() {
        this.chartOptions.yaxis.title = { text: this.reports?.yaxisTitle };
    },
    watch: {
        dates: {
            deep: true,
            handler() {
                if (this.dates.length === 2) {
                    this.getRidesReport(this.dates[0], this.dates[1]);
                    this.getTicketsReport(this.dates[0], this.dates[1]);
                    this.getTicketsHistoryReport(this.dates[0], this.dates[1]);
                    this.getRatingsReport(this.dates[0], this.dates[1]);
                }
            },
        },
    },
});
